var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardExitCrossBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#F2F1ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.293 33.1189C9.90233 33.5093 9.90233 34.1423 10.293 34.5326C10.6837 34.923 11.3171 34.923 11.7077 34.5326L22.4212 23.8268L33.1355 34.5333C33.5261 34.9237 34.1595 34.9237 34.5502 34.5333C34.9408 34.1429 34.9408 33.51 34.5502 33.1196L23.836 22.4131L34.5502 11.7065C34.9408 11.3161 34.9408 10.6832 34.5502 10.2928C34.1595 9.9024 33.5261 9.9024 33.1354 10.2928L22.4212 20.9994L11.7077 10.2935C11.3171 9.90308 10.6837 9.90308 10.293 10.2935C9.90233 10.6839 9.90233 11.3168 10.293 11.7072L21.0065 22.4131L10.293 33.1189Z",
    fill: "#111111"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardExitCrossBlack);
export default __webpack_public_path__ + "static/media/card-exit-cross-black.9f264cccedbb2955819289200600060d.svg";
export { ForwardRef as ReactComponent };